import React from "react";
import Icon from "@ant-design/icons";

const ReturnBackSvg = ({ width = "1rem", height = "1rem", fill = "none" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox={`0 0 ${width - 3} ${height - 3}`}
			fill={fill}
		>
			<path
				d="M5.25 8.75L1.75 5.25M1.75 5.25L5.25 1.75M1.75 5.25H8.75C10.683 5.25 12.25 6.817 12.25 8.75C12.25 10.683 10.683 12.25 8.75 12.25H7"
				stroke="#667085"
				strokeWidth="1.00058"
				strokeLinecap="round"
				strokeLinejoin="round"
				// stroke-width="1.00058"
				// stroke-linecap="round"
				// stroke-linejoin="round"
			/>
		</svg>
	);
};
const ReturnBackIcon = (props) => (
	<Icon component={() => <ReturnBackSvg {...props} />} />
);

export default ReturnBackIcon;
